import config from './config'
import Create from './create'

export default {
  ...config,
  config,
  create: Create,
}
